import * as type from 'constants/action_types/amazon_store'

export const initialState = {
  fetch: {
    isLoading: false
  },
  data: {}
}

function amazonStore(state = initialState, action) {
  switch (action.type) {
    case type.PENDING_AMAZON_STORE_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true
        }
      }
    case type.RESET_AMAZON_STORE_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    case type.SET_AMAZON_STORE_DATA:
      return { ...state, data: action.payload }
    default:
      return state
  }
}

export default amazonStore
